var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMusic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.76 91.92",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.66 0v1.26c0 21-.14 42 .07 63 .12 8.58-6.45 13.94-13.3 14.74a16.09 16.09 0 01-14.16-4.8 12.44 12.44 0 012.37-19.34c6.14-4 12.47-4 18.78-.26l.39.23h.21V20.39l-3.31.8Q52.88 26.35 32 31.48c-.85.21-1 .57-1 1.39 0 14.76-.14 29.52.09 44.27.13 8.72-6.79 13.91-13.3 14.64-5.71.64-10.71-.88-14.58-5.24a12.36 12.36 0 011.62-18.08 17.09 17.09 0 0119.88-1.09l.66.41v-1.15-51.45c0-.76.19-1 1-1.24Q53.82 7.18 81.31.35c.34-.09.66-.23 1-.35z",
    fill: "#878789",
    "data-name": "Capa 1"
  }))));
}

export default SvgMusic;